import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Client, Package } from '../../test-suite/models';
import { ClientPackageMapping } from '../viewmodels/client-package-mapping-viewmodel';

@Injectable({ providedIn: 'root' })
export class ClientPackageMappingService {

    private baseUrl = `${environment.apiUrl}/client-package-mapping`;

    constructor(private http: HttpClient) { }

    public getAllClients(): Observable<Client[]> {
        return this.http.get<Client[]>(`${environment.apiUrl}/clients`);
    }

    public getAllPackages(): Observable<Package[]> {
        return this.http.get<Package[]>(`${environment.apiUrl}/packages`);
    }

    public getAllClientPackageMappings(): Observable<ClientPackageMapping[]> {
        return this.http.get<ClientPackageMapping[]>(this.baseUrl);
    }

    public saveClientPackageMapping(item: ClientPackageMapping): Observable<ClientPackageMapping> {
        if (item.id) {
            return this.updateClientPackageMapping(item);
        } else {
            return this.createClientPackageMapping(item);
        }
    }

    public createClientPackageMapping(item: Partial<ClientPackageMapping>): Observable<ClientPackageMapping> {
        return this.http.post<ClientPackageMapping>(this.baseUrl, item);
    }

    public updateClientPackageMapping(item: Partial<ClientPackageMapping>): Observable<ClientPackageMapping> {
        return this.http.post<ClientPackageMapping>(this.baseUrl, item);
    }

    public deleteClientPackageMapping(id: number): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/${id}`);
    }

    public getIncompleteAuthProfileClients(): Observable<string[]> {
        return this.http.get<string[]>(`${environment.apiUrl}/auth-profiles/incomplete-clients`);
    }
}